import { render } from "./SchemaSolutionPageTabs.vue?vue&type=template&id=15a504c8&scoped=true"
import script from "./SchemaSolutionPageTabs.vue?vue&type=script&lang=js"
export * from "./SchemaSolutionPageTabs.vue?vue&type=script&lang=js"

import "./SchemaSolutionPageTabs.vue?vue&type=style&index=0&id=15a504c8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a504c8"]])

export default __exports__